import AbstractChatConnector from "./abstractChatConnector";
import {ChatType} from "../../../types/enums";

export default class BotChatConnector extends AbstractChatConnector
{
    protected async registerOnMessageHandler( webSocket: WebSocket ):Promise<void>
    {
        webSocket.onmessage = this.messageHandler.handleOnBotMessage;
    }

    public getChatType( ): string
    {
        return ChatType.BOT_CHAT;
    }
}